import NoTaskImage from "../../assets/png/NoTaskImage.png";
import NoSearchTask from "../../assets/png/NoSearchTask.png";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import WbsImport from "@/components/tasks/wbsImport";
import useProjectQuery from "@/api/query/useProjectQuery";
import { useUser } from "@/hooks/useUser";
import { UserRoleEnumValue } from "@backend/src/schemas/enums";
type Props = { projectId: string; refetch: () => void; filtered: boolean, setIsOpenPopUp: (data:boolean) => void; };
function NoTask(props: Props) {
  // const [isOpenPopUp, setIsOpenPopUp] = useState(false);
  const projects = useProjectQuery();
  const user = useUser()
  const isCollaborator = () => {
    const project = projects.data?.data.data.find(
      (p) => p.projectId == props.projectId
    );
    if (
      project?.assignedUsers.find(
        (u) =>
          u.user.userId == user.user?.userId &&
            u.projectRole == UserRoleEnumValue.COLLABORATOR
      ) 
    ) {
      return false;
    }  else {
      return true;
    }
  };
  const {t}=useTranslation();
  return (
    <div className="w-full h-full p-8 ">
      <div
        className={`w-full px-5 h-full flex overflow-auto justify-center items-center border rounded-lg`}
      >
        <div className="flex flex-col justify-center items-center ">
          <div className="text-center text-3xl text-gray-450/40 font-bold">
            {props.filtered ? "Oops!!! " : "Get Started Now!"}
          </div>
          {props.filtered && (
            <div className="text-center text-2xl">
              {t("no_task_with_filter")}
            </div>
          )}
          <div className="p-6">
            <img
              src={props.filtered ? NoSearchTask : NoTaskImage}
              className="w-80"
            />
          </div>
          <div className="lg:flex flex-col justify-between gap-x-5 w-full">
            {!props.filtered && (
              <span className="text-neutral-600 text-3xl font-bold text-center">
                {t("create_your_first_task")}
              </span>
            )}
            <div className="flex items-center ">
              {isCollaborator() && <Button
                variant={"primary"}
                onClick={() => props.setIsOpenPopUp(true)}
                className="!w-full !mt-3 !tracking-wide !lg:mt-0 !lg:w-fit "
              >
                {t("create")}
              </Button>}
            </div>
            <div className="mt-5">
              {isCollaborator() && <WbsImport projectId={props.projectId} refetch={props.refetch}newTask={()=>{}}/>}
            </div>
          </div>
        </div>
      </div>
     
    </div>
  );
}

export default NoTask;
